export const userConstants = {
    LOGIN_REQUEST: 'app/user/USERS_LOGIN_REQUEST',
    LOGIN_SUCCESS: 'app/user/USERS_LOGIN_SUCCESS',
    LOGIN_FAILURE: 'app/user/USERS_LOGIN_FAILURE',
    LOGOUT: 'app/user/USERS_LOGOUT',

};
